// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1v1qB","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3jmTr","obliqueLine":"membershipbadge_obliqueLine__RQjzY"};